import type { ButtonHTMLAttributes } from 'react';

interface FilterChipProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  active?: boolean;
  count?: number;
  children: React.ReactNode;
}

/**
 * 状态/范围筛选 chip。
 *
 * 设计系统（DESIGN.md §10）：
 * - 从 rounded-full pill 糖果型切到 rounded-sm 方圆角（4px）
 *   工业工具不需要糖果感；方圆角更精确、像机床按钮
 * - 激活态 wood-100 浅底 + wood-500 边框 + wood-700 字
 * - 计数用等宽字体 + tabular-nums
 */
export default function FilterChip({ active, count, children, className = '', ...rest }: FilterChipProps) {
  return (
    <button
      {...rest}
      className={`inline-flex items-center gap-1.5 rounded-sm border px-3 py-1 text-xs font-medium transition-colors ${
        active
          ? 'border-wood-500 bg-wood-100 text-wood-700'
          : 'border-birch-200 bg-white text-walnut-700 hover:bg-pine-100'
      } ${className}`}
    >
      {children}
      {typeof count === 'number' && count > 0 ? (
        <span className={`font-mono text-2xs tabular-nums ${active ? 'text-wood-700' : 'text-oak-500'}`}>
          {count}
        </span>
      ) : null}
    </button>
  );
}
